import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";
import store from "../store";

const ReservationStore = {
  namespaced: true,
  debug: true,
  state: {
    reservationList: []
  },
  mutations: {
    setReservationList(state, data) {
      state.reservationList = data;
    }
  },
  getters: {
    getReservationList(state) {
      return state.reservationList.map(val => {
        let result = {
          schedulenumber: val.schedulenumber,
          day: moment(val.startdate).format("YYYY/MM/DD"),
          startTime: moment(val.startdate).format("Ah:mm 開始"),
          endTime: moment(val.enddate).format("Ah:mm 終了"),
          type:
            val.type != null && val.type != ""
              ? store.getters[
                  "constantStore/constant/constantStore/getTypeData"
                ](val.type).label
              : ""
        };
        if (val.status === "Reserved") {
          result.status = "予約中";
          result.color = "red";
        } else {
          result.status = "利用済";
          result.color = "grey";
        }
        return result;
      });
    }
  },
  actions: {
    async callApiReservationList({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let reservationList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/user/reservationList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setReservationList", reservationList.data);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default ReservationStore;
